<template>
  <div :class="display">
    <ul :class="[direction, {wrap: wrap}]">
      <li class="tabItem" v-for="(item, index) in list" :key="index" @click="clickHandler(index)" :class="[isSelect(index), !getDisable(item) ? 'isButton': 'disable', wrap ? 'wrap' : 'nowrap', item.state]" :style="getStyle(item, index)">
        <icon v-if="item.icon !== null && item.icon !== undefined" size="xsmall" :uicon="item.icon"/>
        <span v-html="item.name">{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {type: Number, default: 0},
    type: { type: String, default: 'select' },
    display: { type: String, default: 'titleBar' },
    list: { type: Array, required: true },
    select: { type: Number, default: 0 },
    disable: {type: Boolean, default: false},
    direction: {type: String, default: 'row'},
    wrap: {type: Boolean, default: false}
  },
  created () {
  },
  mounted () {
  },
  data () {
    return {
      selected: null,
      // selectIndex: this.select
      selectIndex: this.value
    }
  },
  name: 'TabBar',
  watch: {
    value (val) {
      if (this.selectIndex !== val) {
        this.selectIndex = val
      }
    }
  },
  methods: {
    getStyle (item, index) {
      if (item.style && item.style.default) {
        return item.style
      }
      if (index === this.selectIndex) {
        return item.style
      } else {
        return null
      }
    },
    getDisable (item) {
      // console.log(item.name, this.disable, item.disable)
      if (this.disable) {
        return this.disable
      } else if (item.disable) {
        return item.disable
      } else {
        return false
      }
    },
    clickHandler (index) {
      if (!this.getDisable(this.list[index])) {
        if (this.selectIndex !== index) {
          this.$emit('input', index)
          this.$emit('selected', {prev: this.selectIndex, param: this.list[index], current: index})
          this.selectIndex = index
        }
      }
    },
    isSelect (index) {
      switch (this.type) {
        case 'select' :
          return (index === this.selectIndex) ? 'select' : 'tab'
        default :
          return 'tab'
      }
    }
  },
  components: {
  }
}
</script>

<style scoped>
.titleBar {
  height: 40px;
  width: 100%;
  border-bottom: 1px solid var(--deactive);
}
.titleBar ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  list-style: none;
}
.titleBar .tabItem {
  width: 140px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: bold;
}
.titleBar .tabItem.isButton {
  color: var(--text-base);
  cursor: pointer;
}
.titleBar .tabItem.disable {
  color: var(--disable);
}
.titleBar .tabItem:first-child {
  border-left: 0px;
}
.titleBar .tabItem.select {
  color: var(--text-title);
}
.titleBar .tabItem.select::after {
  content: '';
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 4px;
  background-color: var(--text-title);
  /* border-bottom: 4px solid var(--text-title); */
  /* color: var(--bg-white); */
  /* color: var(--text-title); */
}
.tabBar {
  display: flex;
  /* width: 100%; */
  flex: 1;
  height: 100%;
  border: 1px solid var(--line-base);
}
.tabBar ul {
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
}
.tabBar .row {
  flex-direction: row;
}
.tabBar .column {
  flex-direction: column;
}
.tabBar .tabItem {
  height: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.tabBar .tabItem.isButton {
  color: var(--text-base);
  background-color: var(--bg-white);
  border-left: 1px solid var(--line-base);
  cursor: pointer;
}
.tabBar .tabItem.disable {
  color: var(--disable);
  background-color: var(--bg-white);
  border-left: 1px solid var(--line-base);
}
.tabBar .tabItem:first-child {
  border-left: 0px;
}
.tabBar .tabItem.select {
  background-color: var(--line-title);
  color: var(--bg-white);
  border-left: 1px solid var(--line-base);
}
.tabButton {
  display: flex;
  width: 100%;
}
.tabButton ul {
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
}
.tabButton .row {
  flex-direction: row;
}
.tabButton .column {
  flex-direction: column;
}
.tabButton .wrap {
  flex-wrap: wrap;
  flex-flow: wrap;
  justify-content: space-between;
}
.tabButton .tabItem {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tabButton .nowrap {
  flex: 1;
  height: 100%;
}
.tabItem.wrap {
  margin-bottom: 5px;
}
.tabButton .row .nowrap.tabItem:nth-child(1n+2) {
  margin-left: 10px;
}
.tabButton .column .nowrap.tabItem:nth-child(1n+2) {
  margin-top: 10px;
}
.tabButton .tabItem.select {
  background-color: var(--deactive);
  border: 1px solid var(--deactive);
  color: var(--bg-white);
}
.tabButton .tabItem.select.require {
  background-color: var(--require);
  border: 1px solid var(--require);
}
.tabButton .tabItem.tab {
  color: var(--text-base);
  background-color: var(--bg-white);
  border: 1px solid var(--line-base);
}
.tabButton .tabItem.tab:hover {
  color: var(--bg-white);
  background-color: var(--line-guide);
  border: 1px solid var(--line-guide);
}
.tabButton .tabItem.tab.require:hover {
  background-color: #F15F5F;
  border: 1px solid #F15F5F;
}
.activeTabButton {
  display: flex;
  width: 100%;
}
.activeTabButton ul {
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
}
.activeTabButton .row {
  flex-direction: row;
}
.activeTabButton .column {
  flex-direction: column;
}
.activeTabButton .tabItem {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.activeTabButton .nowrap {
  flex: 1;
  height: 100%;
}
.activeTabButton.wrap {
  margin-bottom: 5px;
}
.activeTabButton .tabItem span + span {
  margin-left: 5px;
}
.activeTabButton .row .nowrap.tabItem:nth-child(1n+2) {
  margin-left: 10px;
}
.activeTabButton .column .nowrap.tabItem:nth-child(1n+2) {
  margin-top: 10px;
}
.activeTabButton .tabItem.select {
  background-color: var(--active);
  color: var(--bg-white);
}
.activeTabButton .tabItem.select.require {
  background-color: var(--require);
}
.activeTabButton .tabItem.tab {
  color: var(--text-base);
  background-color: var(--bg-white);
  border: 1px solid var(--line-base);
}
.activeTabButton .tabItem.tab:hover {
  color: var(--active);
  background-color: var(--bg-white);
  border: 1px solid var(--active);
}
.activeTabButton .tabItem.tab.require:hover {
  color: var(--require);
  border: 1px solid var(--require);
}
.changeCategory {
  display: flex;
  width: 100%;
}
.changeCategory ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  list-style: none;
}
.changeCategory .tabItem {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  color: var(--text-base);
  background-color: var(--bg-white);
  border: 1px solid var(--line-base);
  padding-left: 15px;
}
.changeCategory .tabItem span + span {
  margin-left: 5px;
}
.changeCategory .tabItem:nth-child(1n+2) {
  margin-top: 5px;
}
.changeCategory .tabItem.select {
  border: 1px solid var(--line-title);
  background-color: var(--line-title);
  color: var(--bg-white);
}
.isButton {
  cursor: pointer;
}

.subTab {
  height: 40px;
  width: 100%;
  border-bottom: 1px solid var(--deactive);
}
.subTab ul {
  width: 100%;
  height: 100%;
  display: inline-flex;
  list-style: none;
}
.subTab .row {
  flex-direction: row;
}
.subTab .column {
  flex-direction: column;
}
.subTab .tabItem {
  width: 120px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-base);
  background-color: var(--bg-white);
  font-size: 12px;
  /* border-left: 1px solid var(--line-base); */
}
.subTab .tabItem:first-child {
  border-left: 0px;
}
.subTab .tabItem.select {
  font-weight: bold;
  color: var(--text-title);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TabBar.vue